import React, { useMemo } from "react";
import { AHRoutineIcon, Box, ListItem } from "arkh";

import { graphql, useFragment } from "react-relay";
import { KPIAdminListItem_Routine$key } from "./__generated__/KPIAdminListItem_Routine.graphql";
import { KPITeamIcon_Team$key } from "./__generated__/KPITeamIcon_Team.graphql";
import { KPITeamIcon } from "./KPITeamIcon";
import { useDaysDescription } from "../components/useDaysDescription";

export function KPIAdminListItem(props: {
  onPress(): void;
  isFirst?: boolean;
  isLast?: boolean;
  kpi: KPIAdminListItem_Routine$key;
}) {
  const data = useFragment(
    graphql`
      fragment KPIAdminListItem_Routine on Routine {
        id
        title
        icon
        schedule {
          rules {
            byweekday
          }
        }
        activeSections {
          id
          assignedTeam {
            id
            ...KPITeamIcon_Team
          }
        }
      }
    `,
    props.kpi
  );

  const teamGroups = useMemo(
    () =>
      data.activeSections.reduce(
        (acc, cur) => {
          if (
            acc.findIndex(
              (section) => section.team.id === cur.assignedTeam?.id
            ) > -1
          ) {
            return acc.map((section) =>
              section.team.id === cur.assignedTeam?.id
                ? { ...section, count: section.count + 1 }
                : section
            );
          } else {
            return [...acc, { team: cur.assignedTeam!, count: 1 }];
          }
        },
        [] as { team: KPITeamIcon_Team$key & { id: string }; count: number }[]
      ),
    [data.activeSections]
  );
  const daysDescription = useDaysDescription(
    data.schedule?.rules[0]?.byweekday?.filter(
      (d) => d !== undefined && d !== null
    ) ?? []
  );

  return (
    <ListItem
      onPress={props.onPress}
      isFirst={props.isFirst}
      isLast={props.isLast}
      border="border-primary"
      left={<AHRoutineIcon type={data.icon ?? "key"} />}
      right={
        <>
          <Box
            style={{
              flexDirection: "row",
              alignItems: "center",
              flexWrap: "wrap",
              justifyContent: "flex-end",
            }}
            spaceHorizontal="xsmall"
          >
            {teamGroups.map((s) => (
              <KPITeamIcon count={s.count} team={s.team} key={s.team.id} />
            ))}
          </Box>
          <ListItem.NavArrow />
        </>
      }
    >
      <ListItem.Title>{data.title}</ListItem.Title>
      <ListItem.SubTitle>{daysDescription}</ListItem.SubTitle>
    </ListItem>
  );
}
